const ClientsDataCategories = [
  { label: "Web", value: "Web" },
  { label: "Soporte web", value: "Soporte web" },
  { label: "SMM", value: "SMM" },
  { label: "SEO", value: "SEO" },
  { label: "ADS", value: "ADS" },
];

export default ClientsDataCategories;
